import {createGlobalStyle} from 'styled-components'
import {fontFace} from '@components/lib'

import RobotoRegular from './fontFiles/Roboto/Roboto-Regular.ttf'
import RobotoMedium from './fontFiles/Roboto/Roboto-Medium.ttf'
import RobotoBold from './fontFiles/Roboto/Roboto-Bold.ttf'
import RalewaySemiBold from './fontFiles/Raleway/Raleway-SemiBold.ttf'

export default createGlobalStyle`
  ${fontFace('Roboto', RobotoRegular, 400)}
  ${fontFace('Roboto', RobotoMedium, 500)}
  ${fontFace('Roboto', RobotoBold, 700)}
  ${fontFace('Raleway', RalewaySemiBold, 600)}
`
